import { usePerpMarkets } from './usePerpMarkets';
import { useMemo } from 'react';

export const usePerpMarketsSortedByMarketIndex = () => {
	const perpMarkets = usePerpMarkets();
	return useMemo(
		() => perpMarkets.sort((a, b) => a.marketIndex - b.marketIndex),
		[perpMarkets]
	);
};
